export const mockData = {
  navigation: {
    logo: "De Leon Rehab Inc",
    menuItems: [
      { label: "About", href: "#about" },
      { label: "Blog", href: "#blog" },
      { label: "Contact", href: "#contact" },
      { label: "Home", href: "#home" },
      { label: "Sample Page", href: "#sample" }
    ],
    ctaButton: "Book Your First Session — No Cost!"
  },
  hero: {
    badge: "Experienced Therapists",
    title: "De Leon Rehab Inc. is a licensed healthcare provider specializing in home-based physical therapy and rehabilitation services.",
    titleHighlight: "",
    description: "We collaborate closely with physicians and healthcare partners to design personalized rehabilitation programs that promote mobility, independence, and overall quality of life.",
    footer: "",
    primaryCta: "Begin Your Journey To Wellness",
    secondaryCta: "Hear From Our Patients"
  },
  galleryImages: [
    "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&q=80&w=600&h=900&crop=",
    "https://images.unsplash.com/photo-1620052079778-7d5b7509645c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&q=80&w=600&h=900&crop=",
    "https://images.unsplash.com/photo-1615506313305-e61daaa8cdcb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&q=80&w=600&h=900&crop="
  ],
  partners: [
    "https://patterns.hiive.cloud/cdn/assets/images/logoipsum-218.png",
    "https://patterns.hiive.cloud/cdn/assets/images/logoipsum-216.png",
    "https://patterns.hiive.cloud/cdn/assets/images/logoipsum-211.png",
    "https://patterns.hiive.cloud/cdn/assets/images/logoipsum-217.png"
  ],
  services: [
    {
      number: "01",
      title: "Orthopedic Rehabilitation",
      description: "We will work with you to create a personalised plan to help you achieve your recovery goals."
    },
    {
      number: "02",
      title: "Neurological Therapy",
      description: "We will work with you to create a personalised plan to help you achieve your recovery goals."
    },
    {
      number: "03",
      title: "Post-Surgical Care",
      description: "We will work with you to create a personalised plan to help you achieve your recovery goals."
    },
    {
      number: "04",
      title: "Balance & Fall Prevention",
      description: "We will work with you to create a personalised plan to help you achieve your recovery goals."
    },
    {
      number: "05",
      title: "Pain Management",
      description: "We will work with you to create a personalised plan to help you achieve your recovery goals."
    },
    {
      number: "06",
      title: "Mobility Training",
      description: "We will work with you to create a personalised plan to help you achieve your recovery goals."
    }
  ],
  features: [
    {
      image1: "https://images.unsplash.com/photo-1518611012118-696072aa579a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHJlc3RhdXJhbnR8ZW58MHwxfDB8fA%3D%3D&auto=format&fit=crop&q=60&w=800&h=&crop=",
      image2: "https://images.unsplash.com/photo-1540474211005-7c8a448f69e6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHJlc3RhdXJhbnR8ZW58MHwxfDB8fA%3D%3D&auto=format&fit=crop&q=60&w=800&h=&crop=",
      title: "Visit Our Expert Physical Therapists",
      description: "Discover exceptional physical therapy services at our state-of-the-art facility. Benefit from a comprehensive range of treatments tailored to your specific needs, delivered by our experienced team.",
      cta: "Schedule Your Appointment"
    },
    {
      image1: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fHJlc3RhdXJhbnR8ZW58MHwxfDB8fA%3D%3D&auto=format&fit=crop&q=60&w=600&h=900&crop=",
      image2: "https://images.unsplash.com/photo-1482049016688-2d3e1b311543?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHJlc3RhdXJhbnR8ZW58MHwxfDB8fA%3D%3D&auto=format&fit=crop&q=60&w=600&h=900&crop=",
      title: "Come and Experience Our Unforgettable Cuisine",
      description: "Experience exquisite fine dining at our newly opened restaurant. Enjoy a delicious menu of classic and modern dishes, prepared with the freshest ingredients.",
      cta: "Learn More"
    }
  ],
  stats: [
    { number: "200+", label: "Patients treated" },
    { number: "24", label: "Treatment sessions" },
    { number: "100+", label: "Recovery success stories" },
    { number: "50+", label: "Specialized treatment programs" }
  ],
  testimonials: [
    {
      rating: 5,
      text: "My experience at the rehabilitation center was great. The therapy was effective, the service was excellent, and the atmosphere was comfortable and professional. Highly recommend this facility.",
      author: "Na-young Han",
      company: "ACME Company",
      avatar: "https://images.unsplash.com/photo-1560253717-c9ece454f7d1?w=200&fit=crop&w=200&h=200&crop=faces"
    },
    {
      rating: 5,
      text: "The physical therapists at De Leon Rehab are exceptional. They created a personalized treatment plan that helped me recover faster than I expected. Professional and caring staff.",
      author: "Michael Rodriguez",
      company: "Tech Solutions Inc",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&fit=crop&w=200&h=200&crop=faces"
    },
    {
      rating: 5,
      text: "Outstanding home-based therapy services. The convenience of receiving treatment at home combined with the expertise of the therapists made my recovery journey smooth and stress-free.",
      author: "Sarah Johnson",
      company: "Healthcare Partners",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&fit=crop&w=200&h=200&crop=faces"
    }
  ],
  detailSection: {
    image: "https://images.unsplash.com/photo-1620052079778-7d5b7509645c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&q=80&w=1500&h=&crop=",
    title: "We pay close attention to every detail so you can relax.",
    features: ["Pain-free experience", "Faultless events"],
    cta: "Schedule an appointment"
  },
  faqs: [
    {
      question: "What services do you offer?",
      answer: "We offer comprehensive home-based physical therapy services including orthopedic rehabilitation, neurological therapy, post-surgical care, balance and fall prevention, pain management, and mobility training."
    },
    {
      question: "Do you accept insurance?",
      answer: "Yes, we accept most major insurance plans. Please contact us to verify your specific coverage and benefits."
    },
    {
      question: "What areas do you serve?",
      answer: "We proudly serve patients throughout South Florida, providing convenient home-based therapy services in the comfort of your own home."
    },
    {
      question: "How do I schedule an appointment?",
      answer: "You can schedule an appointment by clicking the 'Book Your First Session' button or by calling our office directly. Your first consultation is completely free."
    },
    {
      question: "What should I expect during my first session?",
      answer: "During your first session, our licensed therapist will conduct a comprehensive evaluation, discuss your goals, and create a personalized treatment plan tailored to your specific needs."
    }
  ]
};